<div class="boleto-paper">
  <!-- Header -->
  <div class="boleto-header">
    <span>Fatura</span>
  </div>

  <div class="boleto-body">
    <div class="boleto-bar"></div>

    <h2 class="boleto-title">Veja sua fatura de pagamento</h2>
    <p class="boleto-info" *ngIf="infoLine">{{ infoLine }}</p>

    <!-- Valor + Vencimento -->
    <div class="boleto-cards">
      <div class="boleto-card">
        <div class="boleto-card-icon"><i class="fa-solid fa-dollar-sign"></i></div>
        <div class="boleto-card-text">
          <span class="boleto-card-label">Valor</span>
          <strong class="boleto-card-value">R$ {{ amount | number: '1.2-2' }}</strong>
        </div>
      </div>

      <div class="boleto-card">
        <div class="boleto-card-icon"><i class="fa-solid fa-calendar-days"></i></div>
        <div class="boleto-card-text">
          <span class="boleto-card-label">Vencimento</span>
          <strong class="boleto-card-value">{{ dueDate ? (dueDate | date: 'dd/MM/yyyy') : '—' }}</strong>
        </div>
      </div>
    </div>

    <div class="boleto-columns">
      <!-- Beneficiário + Descrição -->
      <div class="boleto-col-left">
        <h3 class="boleto-section">Beneficiário</h3>
        <p class="boleto-strong">{{ beneficiaryName }}</p>
        <p class="boleto-muted">{{ beneficiaryDoc }}</p>

        <h3 class="boleto-section">Descrição</h3>
        <p class="boleto-strong">{{ description }}</p>
        <p class="boleto-muted" *ngIf="descriptionDetail">{{ descriptionDetail }}</p>
      </div>

      <!-- Caixa PIX -->
      <div class="boleto-pix">
        <div class="boleto-pix-head">
          <i class="fa-brands fa-pix"></i> Pagar com PIX
        </div>

        <ol class="boleto-steps">
          <li>Abra o app do seu banco ou instituição financeira e selecione a opção PIX;</li>
          <li>Escolha a opção pagar com QR code e escaneie o código abaixo.</li>
        </ol>

        <div class="boleto-qr">
          <qrcode
            [qrdata]="qrCode || '0000'"
            [width]="160"
            [errorCorrectionLevel]="'H'"
          ></qrcode>
        </div>

        <p class="boleto-copy-label">Ou copie o código de pagamento para pagar:</p>
        <p class="boleto-code">{{ qrCode }}</p>
      </div>
    </div>

    <!-- Status do pagamento -->
    <div class="boleto-status boleto-status--checking" *ngIf="checking && !confirmed">
      <i class="fa-solid fa-spinner fa-spin"></i>
      <span>{{ checkingMessage }}</span>
    </div>
    <div class="boleto-status boleto-status--waiting" *ngIf="timedOut && !confirmed">
      <i class="fa-solid fa-clock"></i>
      <span>{{ timedOutMessage }}</span>
    </div>
    <div class="boleto-status boleto-status--confirmed" *ngIf="confirmed">
      <i class="fa-solid fa-circle-check"></i>
      <span>{{ confirmedMessage }}</span>
    </div>

    <!-- Ações -->
    <div class="boleto-actions" *ngIf="!confirmed">
      <button type="button" class="boleto-btn boleto-btn--ghost" (click)="copy.emit()">
        <i class="fa-regular fa-copy"></i> Copiar código PIX
      </button>
      <button
        type="button"
        class="boleto-btn boleto-btn--primary"
        [disabled]="!canDownload || isDownloading"
        (click)="download.emit()"
      >
        <ng-container *ngIf="!isDownloading">
          <i class="fa-solid fa-download"></i> Baixar PDF
        </ng-container>
        <ng-container *ngIf="isDownloading">
          <i class="fa-solid fa-spinner fa-spin"></i> Gerando...
        </ng-container>
      </button>
    </div>

    <button
      type="button"
      class="boleto-retry"
      *ngIf="!confirmed"
      (click)="retry.emit()">
      Gerar nova fatura
    </button>
  </div>
</div>
